import { PIN_CAP } from '@tunasong/models'

/** Band pin microcopy (GH #2822, docs/ux/2026-10-25-band-pins-ux.md) */
export const bandPinCopy = {
  pinned: (band: string) => `Pinned to ${band} for everyone`,
  unpinned: (band: string) => `Unpinned from ${band}`,
  /** The band starts the sentence, so "your band" is capitalised here only (Joni, #2841 audit 4) */
  full: (band: string) =>
    `${band.charAt(0).toUpperCase()}${band.slice(1)} has ${PIN_CAP} pins. Unpin one to make room.`,
}

/** A band without a name still reads as a sentence (the same fallback the Perform band line uses) */
export const bandLabel = (band?: { name?: string }) => band?.name?.trim() || 'your band'
